import React, { useState, useEffect, useCallback } from "react";
import "./../../../assets/css/purchase/form.css";

// React DateTime
import moment from "moment";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";
import DatePicker from "../../components/DatePicker";
import ArModal from "../../components/Modal/ArModal";

// Utils
import { getAlert, getDataWithComp } from "../../../utils/SamuiUtils";

const DepositReport = () => {
  // ตัวแปรเก็บชื่อหน้าจอ
  const [name, setName] = useState(null);

  // ตัวแปรเก็บค่าเงื่อนไขการค้นหา
  const [searchCriteria, setSearchCriteria] = useState([]);

  // ข้อมูลที่แสดงรายงาน
  const [filteredData, setFilteredData] = useState([]);

  // สำหรับ Modal ลูกค้า
  const [showArModal, setShowArModal] = useState(false);
  const [arDataList, setArDataList] = useState([]);
  const [customerSelected, setCustomerSelected] = useState({
    AR_Code: "",
    AR_Name: "",
  });

  // สำหรับ Dropdown สถานะ - ใช้ hardcode เหมือน SalesReport
  const [docStatusList, setDocStatusList] = useState([
    { DocSetStatus: 1, DocSetStatus_Name: "รอยืนยัน" },
    { DocSetStatus: 2, DocSetStatus_Name: "ลค ยืนยันแล้ว" },
    { DocSetStatus: 3, DocSetStatus_Name: "จ่ายมัดจำแล้ว" },
    { DocSetStatus: 4, DocSetStatus_Name: "คืนเงินครบ" },
    { DocSetStatus: 13, DocSetStatus_Name: "ยกเลิก" },
  ]);

  // สำหรับ Table รายงาน
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(16);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const [exportController, setExportController] = useState({
    exportToExcel: null,
    isExporting: false,
    hasData: false,
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
    setName("4. รายงานมัดจำประจำวัน");
    setSearchCriteria({
      fromDate: moment().format("YYYY-MM-DD"), // แก้ไขให้เป็น date format เท่านั้น
      toDate: moment().format("YYYY-MM-DD"), // แก้ไขให้เป็น date format เท่านั้น
      fromDocNo: "",
      toDocNo: "",
      docStatus: "",
    });
    setFilteredData([]);
    setCustomerSelected({ AR_Code: "", AR_Name: "" });

    // Load รายชื่อลูกค้า
    try {
      const customerDataList = await getDataWithComp(
        "Tb_Set_AR",
        "AND AR_Status = 'Y' ORDER By AR_Code ASC"
      );
      if (customerDataList && customerDataList.length > 0) {
        setArDataList(customerDataList);
      }
    } catch (error) {
      console.error("Error loading customer data:", error);
      getAlert("FAILED", "ไม่สามารถโหลดข้อมูลลูกค้าได้");
    }

    // ไม่ต้องโหลด dropdown สถานะจาก API - ใช้ hardcode เหมือน SalesReport
    // SalesReport ใช้ hardcode ทั้งหมด ไม่มีการเรียก API dropdown เลย
  };

  const handleChangeDate = (value, name) => {
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value ? value.format("YYYY-MM-DD") : null,
    }));
  };

  const handleChangeCriteria = (e) => {
    const { name, value } = e.target;
    setSearchCriteria((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ฟังก์ชันสำหรับ Modal ลูกค้า
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);

  const onRowSelectAr = async (customerSelected) => {
    try {
      setCustomerSelected(customerSelected);
      handleArClose();
    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  const handleSearch = async () => {
    try {
      setFilteredData([]);

      let query = "";

      // เงื่อนไขช่วงวันที่
      if (searchCriteria.fromDate && searchCriteria.toDate) {
        query += `AND (CAST(Doc_Date AS DATE) BETWEEN '${searchCriteria.fromDate}' AND '${searchCriteria.toDate}') `;
      } else if (searchCriteria.fromDate) {
        query += `AND (CAST(Doc_Date AS DATE) >= '${searchCriteria.fromDate}') `;
      } else if (searchCriteria.toDate) {
        query += `AND (CAST(Doc_Date AS DATE) <= '${searchCriteria.toDate}') `;
      }

      // เงื่อนไขช่วงเลขที่เอกสาร
      if (searchCriteria.fromDocNo && searchCriteria.toDocNo) {
        query += `AND Doc_No BETWEEN '${searchCriteria.fromDocNo}' AND '${searchCriteria.toDocNo}' `;
      } else if (searchCriteria.fromDocNo) {
        query += `AND Doc_No >= '${searchCriteria.fromDocNo}' `;
      } else if (searchCriteria.toDocNo) {
        query += `AND Doc_No <= '${searchCriteria.toDocNo}' `;
      }

      // เงื่อนไขลูกค้า
      if (customerSelected?.AR_Code) {
        query += `AND AR_Code = '${customerSelected.AR_Code}' `;
      }

      // เงื่อนไขสถานะ
      if (searchCriteria.docStatus) {
        query += `AND Doc_Status = ${searchCriteria.docStatus} `;
      }

      // เพิ่ม Company ID เหมือน SalesReport
      const companyId = window.localStorage.getItem("company") || 1;
      query += `AND (Comp_Id = ${companyId}) `;

      query += `ORDER BY Doc_Date, Doc_No ASC`;

      const response = await getDataWithComp("API_0501_DEPOS_H", query.trim());

      if (response && response.length > 0) {
        setFilteredData(response);
        getAlert("SUCCESS", `พบข้อมูล ${response.length} รายการ`);
      } else {
        setFilteredData([]);
        getAlert("INFO", "ไม่พบข้อมูลตามเงื่อนไขที่ค้นหา");
      }
    } catch (error) {
      console.error("Search Error:", error); // Debug error
      setFilteredData([]);
      getAlert(
        "FAILED",
        error.response?.data?.message ||
          error.message ||
          "เกิดข้อผิดพลาดในการค้นหาข้อมูล"
      );
    }
  };

  const handleExportReady = useCallback((state) => {
    setExportController((prev) => {
      if (
        prev.exportToExcel === state.exportToExcel &&
        prev.isExporting === state.isExporting &&
        prev.hasData === state.hasData
      ) {
        return prev;
      }
      return state;
    });
  }, []);

  const handleExportClick = useCallback(() => {
    if (exportController?.exportToExcel) {
      exportController.exportToExcel();
    } else {
      getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
    }
  }, [exportController]);

  return (
    <>
      <Sidebar />
      <div className="main-panel">
        <div className="container">
          <div className="page-inner">
            <div className="page-header d-flex justify-content-between align-items-center">
              <Breadcrumbs
                page={name}
                items={[
                  { name: "รายงาน", url: "/reports" },
                  { name: name, url: "/deposit-report" },
                ]}
              />
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <h4>เงื่อนไขการค้นหา</h4>
                  </div>
                  <div className="card-body">
                    <div className="row g-3 align-items-end">
                      {/* ช่วงวันที่ */}
                      <div className="col-md-3">
                        <label htmlFor="fromDate" className="form-label">
                          ค้นหาวันที่
                        </label>
                        <DatePicker
                          label=""
                          name="fromDate"
                          value={searchCriteria.fromDate}
                          onChange={(date) =>
                            handleChangeDate(date, "fromDate")
                          }
                          disabled={false}
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="toDate" className="form-label">
                          ถึงวันที่
                        </label>
                        <DatePicker
                          label=""
                          name="toDate"
                          value={searchCriteria.toDate}
                          onChange={(date) => handleChangeDate(date, "toDate")}
                          disabled={false}
                        />
                      </div>
                      {/* ช่วงเลขที่เอกสาร */}
                      <div className="col-md-3">
                        <label htmlFor="fromDocNo" className="form-label">
                          เลขที่เอกสาร
                        </label>
                        <input
                          type="text"
                          className="form-control input-spacing"
                          id="fromDocNo"
                          name="fromDocNo"
                          value={searchCriteria.fromDocNo || ""}
                          onChange={handleChangeCriteria}
                          placeholder="เลขที่เริ่มต้น"
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="toDocNo" className="form-label">
                          ถึงเลขที่
                        </label>
                        <input
                          type="text"
                          className="form-control input-spacing"
                          id="toDocNo"
                          name="toDocNo"
                          value={searchCriteria.toDocNo || ""}
                          onChange={handleChangeCriteria}
                          placeholder="เลขที่สิ้นสุด"
                        />
                      </div>
                      {/* ลูกค้า */}
                      <div className="col-md-3">
                        <label className="form-label">ลูกค้า</label>
                        <div className="input-group">
                          <input
                            type="text"
                            className="form-control input-spacing"
                            name="customerName"
                            value={
                              customerSelected?.AR_Code
                                ? `${customerSelected.AR_Code} - ${customerSelected.AR_Name}`
                                : ""
                            }
                            disabled={true}
                          />
                          <button
                            className="btn btn-outline-secondary"
                            onClick={(e) => {
                              e.preventDefault();
                              handleArShow();
                            }}
                          >
                            <i className="fas fa-search"></i>
                          </button>
                        </div>
                      </div>
                      {/* สถานะ */}
                      <div className="col-md-3">
                        <label htmlFor="docStatus" className="form-label">
                          สถานะ
                        </label>
                        <select
                          className="form-select form-control input-spacing"
                          id="docStatus"
                          name="docStatus"
                          value={searchCriteria.docStatus || ""}
                          onChange={handleChangeCriteria}
                        >
                          <option value="">ทั้งหมด</option>
                          {docStatusList.map((status) => (
                            <option
                              key={status.DocSetStatus}
                              value={status.DocSetStatus}
                            >
                              {status.DocSetStatus_Name}
                            </option>
                          ))}
                        </select>
                      </div>
                      {/* Buttons */}
                      <div className="col-md-6 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white me-2"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            flex: 1,
                            maxWidth: "150px",
                          }}
                          onClick={() => handleSearch()}
                        >
                          <i className="fas fa-search" /> ค้นหา
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white me-2"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            flex: 1,
                            maxWidth: "150px",
                          }}
                          onClick={handleExportClick}
                          disabled={
                            !exportController.hasData || exportController.isExporting
                          }
                        >
                          <i className="fas fa-file-excel" />{" "}
                          {exportController.isExporting ? "กำลังส่งออก..." : "Export"}
                        </button>
                        <button
                          type="button"
                          className="btn btn-lg shadow text-white"
                          style={{
                            backgroundColor: "#EF6C00",
                            fontSize: "16px",
                            flex: 1,
                            maxWidth: "150px",
                          }}
                          onClick={() => initialize()}
                        >
                          <i className="fas fa-undo" /> เริ่มใหม่
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* AR Modal */}
              <ArModal
                showArModal={showArModal}
                handleArClose={handleArClose}
                arDataList={arDataList}
                onRowSelectAr={onRowSelectAr}
              />

              {/* ReportsTable */}
              <ReportsTable
                currentItems={currentItems}
                currentPage={currentPage}
                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                dataMasterList={filteredData}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
                fieldMappings={{
                  docDate: "Doc_Date",
                  docNo: "Doc_No",
                  docStatusName: "DocStatus_Name",
                  docStatusColor: "docsetcolour",
                  arCode: "AR_Code",
                  arName: "AR_Name",
                  netTotal: "NetTotal",
                }}
                onExportReady={handleExportReady}
                showExportButton={false}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepositReport;
